//import { Banco } from './banco';
import { FormaPago } from './forma-pago';
import { TipoTarjeta } from './tipo-tarjeta';

export class Tarjeta{
    public constructor(
        public id: String = "",
        public forma_pago_id: String = "3",
        public debito_credito: String = "",
        public tipo_id: String = "",
        public valor: number = 0,
        public plazo: number = 0,
        public tiempo: String = "dias",
        public observacion: String = "",
        //public banco_id: String = "",

        //public banco: Banco = new Banco(),
        public forma_pago: FormaPago = new FormaPago(),
        public tipo: TipoTarjeta = new TipoTarjeta()
    ){}
}



// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/models/tarjeta.ts